import React, { useEffect, useState, ReactNode } from "react";

interface ReCaptchaLoaderProps {
  children: ReactNode;
}

const ReCaptchaLoader: React.FC<ReCaptchaLoaderProps> = ({ children }) => {
  const captchaKey = import.meta.env.VITE_GOOGLE_CAPTCHA_KEY;
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!captchaKey) return;

    const existingScript =
      document.querySelector<HTMLScriptElement>("#recaptcha-script");

    const handleScriptLoad = () => {
      if (window.grecaptcha) {
        setIsLoaded(true);
      }
    };

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${import.meta.env.VITE_GOOGLE_CAPTCHA_KEY}`;
      script.id = "recaptcha-script";
      script.async = true;
      script.defer = true;
      script.onload = handleScriptLoad;
      document.body.appendChild(script);
    } else if (window.grecaptcha) {
      setIsLoaded(true);
    } else {
      existingScript.addEventListener("load", handleScriptLoad);
    }

    return () => {
      existingScript?.removeEventListener("load", handleScriptLoad);
    };
  }, [captchaKey]);

  return isLoaded || !captchaKey ? <>{children}</> : null;
};

export default ReCaptchaLoader;
